import Page from '@admin/components/page'
import Overview from './overview'
import Design from './design'
import React from 'react'

const mapPropsToPage = (props, context, resources, page) => ({
  title: resources.landing_page.title,
  manager: {
    path: `/admin/forms/forms/${resources.form.id}/landing_pages/${resources.landing_page.id}`,
    items: [
      {
        label: 't(Overview)',
        panel: <Overview form={ resources.form } landing_page={ resources.landing_page } />
      },
      {
        label: 't(Design)',
        path: '/design',
        panel: <Design form={ resources.form } landing_page={ resources.landing_page } />
      }
    ]
  }
})

const mapResourcesToPage = (props, context) => ({
  form: `/api/admin/forms/forms/${props.params.form_id}`,
  landing_page: `/api/admin/forms/forms/${props.params.form_id}/landing_pages/${props.params.id}`
})

export default Page(mapResourcesToPage, mapPropsToPage)
